import { createStyles, makeStyles } from '@material-ui/core/styles';

const useTopBarMobileStyles = makeStyles(() => createStyles({
    hide: { display: 'none' },
    menuButton: { marginRight: 36 },
}));

export default useTopBarMobileStyles;
